/**
 * Generated from PostcardCusco2Layout.fla
 */
export function PostcardCusco2Layout(this: IPostcardCusco2Layout) {
	const main = this.main;
	PostcardCusco2Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardCusco2Layout_main(this: IPostcardCusco2Layout_main) {
	const postcard = this.postcard;
	PostcardCusco2Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardCusco2Layout_postcard(this: IPostcardCusco2Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardCusco2Layout_cardTransform1.call(cardTransform[0] as IPostcardCusco2Layout_cardTransform1);
		cardTransform[0].x = -631.2;
		cardTransform[0].y = -402.6;
		cardTransform[0].width = 507.15;
		cardTransform[0].height = 635.69;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardCusco2Layout_cardTransform2.call(cardTransform[1] as IPostcardCusco2Layout_cardTransform2);
		cardTransform[1].x = -419.9;
		cardTransform[1].y = -218.7;
		cardTransform[1].width = 561.71;
		cardTransform[1].height = 704.09;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardCusco2Layout_cardTransform3.call(cardTransform[2] as IPostcardCusco2Layout_cardTransform3);
		cardTransform[2].x = -27.6;
		cardTransform[2].y = -172.2;
		cardTransform[2].width = 712.19;
		cardTransform[2].height = 892.71;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardCusco2Layout_cardTransform4.call(cardTransform[3] as IPostcardCusco2Layout_cardTransform4);
		cardTransform[3].x = 509.1;
		cardTransform[3].y = -101.45;
		cardTransform[3].width = 631.90;
		cardTransform[3].height = 792.05;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardCusco2Layout_cardTransform5.call(cardTransform[4] as IPostcardCusco2Layout_cardTransform5);
		cardTransform[4].x = -4.5;
		cardTransform[4].y = 419.55;
		cardTransform[4].width = 527.88;
		cardTransform[4].height = 661.68;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardCusco2Layout_cardTransform6.call(cardTransform[5] as IPostcardCusco2Layout_cardTransform6);
		cardTransform[5].x = -440.95;
		cardTransform[5].y = 357.2;
		cardTransform[5].width = 497.88;
		cardTransform[5].height = 624.08;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardCusco2Layout_cardTransform7.call(cardTransform[6] as IPostcardCusco2Layout_cardTransform7);
		cardTransform[6].x = 508.55;
		cardTransform[6].y = 348.9;
		cardTransform[6].width = 762.26;
		cardTransform[6].height = 955.47;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardCusco2Layout_cardTransform8.call(cardTransform[7] as IPostcardCusco2Layout_cardTransform8);
		cardTransform[7].x = 503.9;
		cardTransform[7].y = -242.3;
		cardTransform[7].width = 642.80;
		cardTransform[7].height = 805.73;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[0]) {
		PostcardCusco2Layout_pieces1.call(items[0] as IPostcardCusco2Layout_pieces1);
		(items[0] as IPostcardCusco2Layout_pieces1).dependsOn = 0;
		(items[0] as IPostcardCusco2Layout_pieces1).outlineGlow = true;
		items[0].x = -635.35;
		items[0].y = -386.7;
		items[0].width = 360.00;
		items[0].height = 421.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardCusco2Layout_outlines1.call(items[1] as IPostcardCusco2Layout_outlines1);
		items[1].x = -629;
		items[1].y = -420.6;
		items[1].width = 336.00;
		items[1].height = 357.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[2]) {
		PostcardCusco2Layout_pieces2.call(items[2] as IPostcardCusco2Layout_pieces2);
		(items[2] as IPostcardCusco2Layout_pieces2).dependsOn = 0;
		(items[2] as IPostcardCusco2Layout_pieces2).outlineGlow = true;
		items[2].x = -429.2;
		items[2].y = -206.85;
		items[2].width = 432.99;
		items[2].height = 490.99;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardCusco2Layout_outlines2.call(items[3] as IPostcardCusco2Layout_outlines2);
		items[3].x = -434.45;
		items[3].y = -204.55;
		items[3].width = 419.00;
		items[3].height = 483.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[4]) {
		PostcardCusco2Layout_pieces3.call(items[4] as IPostcardCusco2Layout_pieces3);
		(items[4] as IPostcardCusco2Layout_pieces3).dependsOn = 0;
		(items[4] as IPostcardCusco2Layout_pieces3).outlineGlow = true;
		items[4].x = -25.7;
		items[4].y = -153.6;
		items[4].width = 433.00;
		items[4].height = 745.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		PostcardCusco2Layout_outlines3.call(items[5] as IPostcardCusco2Layout_outlines3);
		items[5].x = 16.2;
		items[5].y = -167.2;
		items[5].width = 433.00;
		items[5].height = 735.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[6]) {
		PostcardCusco2Layout_pieces8.call(items[6] as IPostcardCusco2Layout_pieces8);
		(items[6] as IPostcardCusco2Layout_pieces8).dependsOn = 0;
		(items[6] as IPostcardCusco2Layout_pieces8).outlineGlow = true;
		items[6].x = 511.4;
		items[6].y = -207.15;
		items[6].width = 501.00;
		items[6].height = 299.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardCusco2Layout_outlines8.call(items[7] as IPostcardCusco2Layout_outlines8);
		items[7].x = 511.9;
		items[7].y = -249.15;
		items[7].width = 499.00;
		items[7].height = 218.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[8]) {
		PostcardCusco2Layout_pieces5.call(items[8] as IPostcardCusco2Layout_pieces5);
		(items[8] as IPostcardCusco2Layout_pieces5).dependsOn = 0;
		(items[8] as IPostcardCusco2Layout_pieces5).outlineGlow = true;
		items[8].x = -82.95;
		items[8].y = 368.2;
		items[8].width = 604.00;
		items[8].height = 397.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,undefined);
	}
	if (items[9]) {
		PostcardCusco2Layout_outlines5.call(items[9] as IPostcardCusco2Layout_outlines5);
		items[9].x = -82.45;
		items[9].y = 364.7;
		items[9].width = 602.00;
		items[9].height = 391.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[10]) {
		PostcardCusco2Layout_pieces6.call(items[10] as IPostcardCusco2Layout_pieces6);
		(items[10] as IPostcardCusco2Layout_pieces6).dependsOn = 0;
		(items[10] as IPostcardCusco2Layout_pieces6).outlineGlow = true;
		items[10].x = -449.75;
		items[10].y = 425.7;
		items[10].width = 564.00;
		items[10].height = 487.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,undefined);
	}
	if (items[11]) {
		PostcardCusco2Layout_outlines6.call(items[11] as IPostcardCusco2Layout_outlines6);
		items[11].x = -541.75;
		items[11].y = 319.7;
		items[11].width = 548.00;
		items[11].height = 483.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,undefined);
	}
	if (items[12]) {
		PostcardCusco2Layout_pieces7.call(items[12] as IPostcardCusco2Layout_pieces7);
		items[12].x = 506.55;
		items[12].y = 334.35;
		items[12].width = 594.00;
		items[12].height = 417.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,undefined);
	}
	if (items[13]) {
		PostcardCusco2Layout_outlines7.call(items[13] as IPostcardCusco2Layout_outlines7);
		items[13].x = 506.05;
		items[13].y = 334.4;
		items[13].width = 594.00;
		items[13].height = 419.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	const shapes = this.shapes;
	if (!shapes[0] && shapes.elementFactory) {
		shapes[0] = shapes.elementFactory(0,undefined);
	}
	if (shapes[0]) {
		shapes[0] = [5.00,0.00];
	}
	if (!shapes[1] && shapes.elementFactory) {
		shapes[1] = shapes.elementFactory(1,undefined);
	}
	if (shapes[1]) {
		shapes[1] = [-215.90,-460.95,-199.50,-393.90,-323.30,-56.70,-483.35,61.40,-550.05,55.70,-660.50,-24.30,-668.15,-91.00,-559.55,-256.75,-399.50,-369.15,-344.95,-423.85,-288.80,-480.90];
	}
	const background = this.background;
	PostcardCusco2Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardCusco2Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardCusco2Layout_background(this: IPostcardCusco2Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-cusco-2.png", 0.500, 0.500);
	return this;
}
function PostcardCusco2Layout_cardTransform6(this: IPostcardCusco2Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-2-6.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_cardTransform2(this: IPostcardCusco2Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-2-2.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_cardTransform4(this: IPostcardCusco2Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-2-4.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_cardTransform3(this: IPostcardCusco2Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-2-3.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_cardTransform5(this: IPostcardCusco2Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-2-5.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_cardTransform1(this: IPostcardCusco2Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-2-1.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_cardTransform7(this: IPostcardCusco2Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-2-7.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_cardTransform8(this: IPostcardCusco2Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-cusco-2-8.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_pieces1(this: IPostcardCusco2Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-2-1.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_outlines1(this: IPostcardCusco2Layout_outlines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-2-1.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_pieces2(this: IPostcardCusco2Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-2-2.png", 0.501, 0.501);
	return this;
}
function PostcardCusco2Layout_outlines2(this: IPostcardCusco2Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-2-2.png", 0.501, 0.501);
	return this;
}
function PostcardCusco2Layout_pieces3(this: IPostcardCusco2Layout_pieces3) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-2-3.png", 0.404, 0.513);
	return this;
}
function PostcardCusco2Layout_outlines3(this: IPostcardCusco2Layout_outlines3) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-2-3.png", 0.501, 0.501);
	return this;
}
function PostcardCusco2Layout_pieces8(this: IPostcardCusco2Layout_pieces8) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-2-8.png", 0.501, 0.502);
	return this;
}
function PostcardCusco2Layout_outlines8(this: IPostcardCusco2Layout_outlines8) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-2-8.png", 0.501, 0.500);
	return this;
}
function PostcardCusco2Layout_pieces5(this: IPostcardCusco2Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-2-5.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_outlines5(this: IPostcardCusco2Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-2-5.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_pieces6(this: IPostcardCusco2Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-2-6.png", 0.649, 0.713);
	return this;
}
function PostcardCusco2Layout_outlines6(this: IPostcardCusco2Layout_outlines6) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-2-6.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_pieces7(this: IPostcardCusco2Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-cusco-2-7.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_outlines7(this: IPostcardCusco2Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-cusco-2-7.png", 0.500, 0.501);
	return this;
}
function PostcardCusco2Layout_shapes1(this: IPostcardCusco2Layout_shapes1) {
	return this;
}
function PostcardCusco2Layout_shapes2(this: IPostcardCusco2Layout_shapes2) {
	return this;
}
function PostcardCusco2Layout_postcardOverlay(this: IPostcardCusco2Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardCusco2Layout_postcardMask(this: IPostcardCusco2Layout_postcardMask) {
	return this;
}
interface IPostcardCusco2LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardCusco2LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardCusco2LayoutSprite extends IPostcardCusco2LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardCusco2LayoutText extends IPostcardCusco2LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardCusco2LayoutPolygon extends Array<number> {
}
interface IPostcardCusco2Layout {
	readonly main: IPostcardCusco2Layout_main;
}
interface IPostcardCusco2Layout_main extends IPostcardCusco2LayoutContainer {
	readonly postcard: IPostcardCusco2Layout_postcard;
}
interface IPostcardCusco2Layout_postcard extends IPostcardCusco2LayoutContainer {
	readonly cardTransform: IPostcardCusco2LayoutArray<IPostcardCusco2Layout_cardTransform1|IPostcardCusco2Layout_cardTransform2|IPostcardCusco2Layout_cardTransform3|IPostcardCusco2Layout_cardTransform4|IPostcardCusco2Layout_cardTransform5|IPostcardCusco2Layout_cardTransform6|IPostcardCusco2Layout_cardTransform7|IPostcardCusco2Layout_cardTransform8>;
	readonly items: IPostcardCusco2LayoutArray<IPostcardCusco2Layout_pieces1|IPostcardCusco2Layout_outlines1|IPostcardCusco2Layout_pieces2|IPostcardCusco2Layout_outlines2|IPostcardCusco2Layout_pieces3|IPostcardCusco2Layout_outlines3|IPostcardCusco2Layout_pieces8|IPostcardCusco2Layout_outlines8|IPostcardCusco2Layout_pieces5|IPostcardCusco2Layout_outlines5|IPostcardCusco2Layout_pieces6|IPostcardCusco2Layout_outlines6|IPostcardCusco2Layout_pieces7|IPostcardCusco2Layout_outlines7>;
	readonly shapes: IPostcardCusco2LayoutArray<IPostcardCusco2Layout_shapes1|IPostcardCusco2Layout_shapes2>;
	readonly background: IPostcardCusco2Layout_background;
	readonly postcardOverlay: IPostcardCusco2Layout_postcardOverlay;
	readonly postcardMask: IPostcardCusco2Layout_postcardMask;
}
interface IPostcardCusco2Layout_background extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_cardTransform6 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_cardTransform2 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_cardTransform4 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_cardTransform3 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_cardTransform5 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_cardTransform1 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_cardTransform7 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_cardTransform8 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_pieces1 extends IPostcardCusco2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardCusco2Layout_outlines1 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_pieces2 extends IPostcardCusco2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardCusco2Layout_outlines2 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_pieces3 extends IPostcardCusco2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardCusco2Layout_outlines3 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_pieces8 extends IPostcardCusco2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardCusco2Layout_outlines8 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_pieces5 extends IPostcardCusco2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardCusco2Layout_outlines5 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_pieces6 extends IPostcardCusco2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardCusco2Layout_outlines6 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_pieces7 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_outlines7 extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_shapes1 extends IPostcardCusco2LayoutPolygon {
}
interface IPostcardCusco2Layout_shapes2 extends IPostcardCusco2LayoutPolygon {
}
interface IPostcardCusco2Layout_postcardOverlay extends IPostcardCusco2LayoutSprite {
}
interface IPostcardCusco2Layout_postcardMask extends IPostcardCusco2LayoutPolygon {
}
